export const USER_GUIDE_URL = process.env.VUE_APP_USER_GUIDE_URL || "https://guide.exiqtive.com";
